// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__TptY5","head":"ProcedureTableInfo_head__1tZed"};